import type {ReactNode} from "react";
import {AssistantRuntimeProvider, useLocalRuntime} from "@assistant-ui/react";
import {createChatModelAdapter} from "@/lib/chat-runtime";

interface ChatRuntimeProviderProps {
  children: ReactNode;
}

export function ChatRuntimeProvider({children}: ChatRuntimeProviderProps) {
  const adapter = createChatModelAdapter();
  const runtime = useLocalRuntime(adapter);

  return <AssistantRuntimeProvider runtime={runtime}>{children}</AssistantRuntimeProvider>;
}
